import { z } from 'zod';
import { requireFields, yesNoRequired } from '@utils/form-schema';

export const assessHeartAttackSchema = z
    .object({
        hasHadHeartAttack: yesNoRequired,
        heartAttackRemissionStatus: z.string(),
    })
    .superRefine((data, ctx) => {
        if (data.hasHadHeartAttack === '1') {
            requireFields(ctx, data, 'heartAttackRemissionStatus');
        }
    });
